<template>
    <div class="welcome">
        <div v-if="!selectedLanguage" class="welcome__inner">
            <div class="category-title">Choose Language</div>
            <button
                v-for="button in languages"
                :key="button.key"
                @click="setSelectedLanguage(button)"
                type="submit"
                name="code"
                value="ar"
                class="welcome__btn"
                style="width: 100%">
                {{ button.value }}
            </button>
        </div>
        <div v-else>
            <div class="category-title">Choose a Category</div>
            <button
                @click="setFilterAndReady(null)"
                type="submit"
                name="code"
                value="ar"
                class="welcome__btn"
                style="width: 100%">
                {{ t('message["All"]', 'All') }}
            </button>
            <button
                v-for="button in categories"
                :key="button.key"
                @click="setFilterAndReady(button)"
                type="submit"
                name="code"
                value="ar"
                class="welcome__btn"
                style="width: 100%">
                {{ button.name[selectedLanguage.key] }}
            </button>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import language from '../../mixins/translate'

    export default {
        mixins: [language],
        computed: {
            ...mapState('settings', ['availableLanguages', 'selectedLanguage']),
            ...mapState('products', ['categories', 'products']),
            languages() {
                return Object.keys(this.availableLanguages)
                    .map(key => ({
                        key,
                        value: this.availableLanguages[key]
                    }))
            }
        },
        methods: {
            ...mapActions('settings', ['setSelectedLanguage', 'setIsReady']),
            ...mapActions('products', ['setFilter']),
            setFilterAndReady(value) {
                if (value) {
                    value.products = this.products.filter(product => {
                        const itemCategoriesIds = product.categories.map(cat => cat.id);
                        return !!itemCategoriesIds.includes(value.id);
                    });
                }
                this.setIsReady(true)
                this.setFilter(value)
            }
        }
    }
</script>


<style>
.welcome {
  margin: 30px 0;
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
}
</style>